module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pt-5697f2973616282e4c76ffeadbc78f0a.svg";